import React from 'react';
import { Link } from 'react-router-dom';
import { Eye } from 'react-bootstrap-icons';
import socLogo from '../assets/soc-logo.webp';
import isoLogo from '../assets/iso-logo-white.webp';
import logo from '../assets/tms-logo.webp';
import LinkedinLogo from '../assets/LinkedIn-logo.webp';

const Footer = () => {
    return (
        <footer className="w-full bg-[#090E1B] text-[#090E1B]">
            <div className="site-shell flex flex-col gap-6 py-6 mb-10">
                <div className="flex flex-col lg:flex-row justify-between items-center gap-6">
                    <div className="flex-shrink-0">
                        <img src={logo} alt="TMS" className="h-8 w-auto object-contain" />
                    </div>
                    <nav className="flex flex-wrap justify-center gap-6 md:gap-16">
                        <Link to="/" className="font-inter font-normal text-[14px] text-[#FFFFFF] hover:text-[#00C2FF] transition-colors">Home</Link>
                        <Link to="/features" className="font-inter font-normal text-[14px] text-[#FFFFFF] hover:text-[#00C2FF] transition-colors">Features</Link>
                        <Link to="/how-we-engage" className="font-inter font-normal text-[14px] text-[#FFFFFF] hover:text-[#00C2FF] transition-colors">How We Engage</Link>
                        <Link to="/how-it-works" className="font-inter font-normal text-[14px] text-[#FFFFFF] hover:text-[#00C2FF] transition-colors">How it Works</Link>
                        <Link to="/security" className="font-inter font-normal text-[14px] text-[#FFFFFF] hover:text-[#00C2FF] transition-colors">Security</Link>
                    </nav>
                </div>

                <div className="h-px bg-gray-700 w-full" />

                <div className="flex flex-row flex-wrap justify-between items-center gap-2 sm:gap-3">
                    <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0">
                        <img src={socLogo} alt="SOC Certified" className="h-10 sm:h-12 w-auto flex-shrink-0" loading="lazy" />
                        <img src={isoLogo} alt="ISO Certified" className="h-10 sm:h-12 w-auto flex-shrink-0" loading="lazy" />
                    </div>
                    <div className="flex flex-row items-center gap-2 sm:gap-3 min-w-0">
                        <Link
                            to="/brochure"
                            className="flex items-center gap-1.5 sm:gap-2 bg-white hover:bg-gray-100 text-[#090E1B] font-inter font-normal text-[13px] sm:text-[16px] px-3 sm:px-6 py-2 rounded-[4px] transition-colors whitespace-nowrap"
                        >
                            <Eye size={18} />
                            <span className="hidden sm:inline">View Brochure</span>
                            <span className="sm:hidden">Brochure</span>
                        </Link>
                        <Link
                            to="https://www.linkedin.com/company/fintechglobalcenter/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center justify-center gap-2 bg-[#0A66C2] hover:bg-[#084d94] text-white font-inter font-semibold text-[16px] rounded-[4px] transition-colors p-2 md:px-6 md:py-2"
                        >
                            <img src={LinkedinLogo} alt="LinkedIn" className="h-5 w-5 flex-shrink-0" />
                            <span className="hidden md:inline whitespace-nowrap">Follow us on LinkedIn</span>
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
